import { ControlGroup, Popover, Tag } from '@blueprintjs/core';
import { DatePicker } from '@blueprintjs/datetime';
import { Users } from '@just-in-types';
import { format, subYears } from 'date-fns';
import * as React from 'react';
import { updateCheckIn, updateUser } from '../../../store/actions';
import { isTimestamp } from '../helpers';

interface Props {
  checkIn: Users.CheckIn;
}
interface State {
  isOpen: boolean;
  dateofbirth: any;
  loading: boolean;
}

class DateOfBirth extends React.Component<Props, State> {
  private datePickerProps;

  public constructor(props: Props) {
    super(props);

    this.datePickerProps = this.getDatePickerProps();

    this.state = {
      dateofbirth: null,
      isOpen: false,
      loading: false,
    };
  }

  public componentDidUpdate({ checkIn: prevCheckIn }: Props) {
    const { checkIn } = this.props;

    if (prevCheckIn.checkInId !== checkIn.checkInId) {
      this.processDateOfBirthProp(checkIn);
    }
  }

  public render() {
    const { isOpen, loading } = this.state;
    let dateofbirth = this.state.dateofbirth
    if(typeof dateofbirth === 'string'){
      dateofbirth = new Date(dateofbirth);
    }

    return (
      <ControlGroup
        fill={true}
        style={{
          display: 'grid',
          gridTemplateColumns: '30% 1fr',
          marginBottom: '0.5rem',
        }}>
        <Tag large={true}>Date of Birth</Tag>
        <style>
          {/* It's surprisingly difficult to style the popover target. */}
          {`
            .date-of-birth-popover,
            .date-of-birth-popover .bp3-tag {
              width: 100%;
            }
          `}
        </style>
        <Popover
          content={
            <DatePicker
              {...this.datePickerProps}
              onChange={this.handleDateOfBirth}
              value={
                dateofbirth instanceof Date
                  ? dateofbirth
                  : subYears(new Date(), 18)
              }
            />
          }
          disabled={loading}
          target={
            <Tag
              interactive={true}
              large={true}
              minimal={true}
              onClick={this.openDatePicker}
              rightIcon="edit">
              {dateofbirth instanceof Date
                ? format(dateofbirth, 'M/D/YY')
                : 'No Date of Birth'}
            </Tag>
          }
          targetClassName={'date-of-birth-popover'}
          onClose={this.closeDatePicker}
          isOpen={isOpen}
        />
      </ControlGroup>
    );
  }

  private processDateOfBirthProp = (checkIn: Users.CheckIn) => {
    const dateofbirth = checkIn.dateofbirth
      ? isTimestamp(checkIn.dateofbirth)
        ? checkIn.dateofbirth.toDate()
        : checkIn.dateofbirth
      : null;

    this.setState({ dateofbirth });
  };

  private getDatePickerProps = () => {
    const thisYear = new Date().getFullYear();
    const minYear = thisYear - 123;

    return {
      minDate: new Date(`1/1/${minYear}`),
    };
  };

  private handleDateOfBirth = async (
    dateofbirth: Date,
    isDayChange: boolean,
  ) => {
    if (isDayChange) {
      const {
        checkIn: { checkInId, userId },
      } = this.props;

      this.setState({ isOpen: false, dateofbirth, loading: true });

      await Promise.all([
        updateUser({
          update: { dateofbirth },
          userId,
        }),
        updateCheckIn({ checkInId, update: { dateofbirth } }),
      ]);

      this.setState({ loading: false });
    }
  };

  private openDatePicker = () => this.setState({ isOpen: true });
  private closeDatePicker = () => this.setState({ isOpen: false });
}

export default DateOfBirth;



// WEBPACK FOOTER //
// ./src/views/CheckIns/ActiveCheckIn/DateOfBirth.tsx